import TextField, { TextFieldProps } from 'atoms/TextField';
import cn from 'classnames';
import React from 'react';
import { Controller } from 'react-hook-form';
import { errorMessage } from 'utils/errorUtils';

import s from './FormField.module.scss';

export interface IFormInputText {
  name: string;
  defaultValue?: unknown;
  description: string;
  type?: string;
  autoFocus?: boolean;
  autoComplete?: string;
  disabled?: boolean;
  multiline?: boolean;
  className?: string;
  variant?: 'outlined' | 'standard' | 'filled' | undefined;
  TextFieldProps?: TextFieldProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any;
}

const FormInputText = ({
  name,
  type = 'text',
  control,
  description,
  autoComplete,
  autoFocus,
  disabled,
  multiline,
  defaultValue,
  className,
  TextFieldProps,
  variant = 'outlined'
}: IFormInputText) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? ''}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          id={name}
          name={name}
          inputProps={{
            'data-testid': name
          }}
          key={name}
          type={type}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          className={cn(s.FormField__textField, className)}
          disabled={disabled}
          multiline={multiline}
          label={description}
          value={value}
          onChange={onChange}
          variant={variant}
          error={!!error}
          helperText={errorMessage(error, 'Invalid Value')}
          {...TextFieldProps}
        />
      )}
    />
  );
};

export default FormInputText;
